<template>
  <div>
    <AppHeader />
    <v-divider></v-divider>

    <v-app-bar
      v-if="$vuetify.breakpoint.name !== 'xs'"
      class="hidden-xs-only"
      :color="transAppBar ? 'white' : 'white'"
      :height="'99px'"
      elevation="1"
      app
    >
      <v-layout wrap justify-center>
        <v-flex align-self-center xs12 px-md-14>
          <v-layout wrap justify-center>
            <v-flex align-self-center sm6 md6 lg6>
              <v-layout wrap justify-start>
                <!-- <v-flex xs2 sm3 md3 lg2 xl1 pa-3 align-self-center text-left>
                  <router-link class="routerlink" :to="(name = '/')">
                    <v-img
                      :src="require('./../assets/images/TigerLogo.jpg')"
                    ></v-img>
                  </router-link>
                </v-flex> -->
                <v-flex xs2 sm1 md1 lg6 align-self-center text-left>
                  <div>
                    <router-link class="routerlink" :to="(name = '/')">
                      <span class="maintitle"> TIGERTHON </span>
                    </router-link>
                  </div>
                </v-flex>
                <v-flex xs12 class="Subt" align-self-center text-left>
                  A technology innovation challenge to #savethestripes
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex align-self-center xs8 sm6 md6 lg6 text-right>
              <v-layout wrap justify-end>
                <v-flex sm12 md12 lg12 align-self-center text-right>
                  <v-layout wrap justify-end>
                     <v-flex sm4 md4 lg3 xl2 align-self-center text-right>
                      <router-link class="routerlink hov" to="/About">
                        <span
                          :class="
                            $vuetify.breakpoint.name == 'md'
                              ? 'MDapplist'
                              : 'LGapplist'
                          "
                        >
                          About Us
                        </span>
                      </router-link>
                    </v-flex>
                  
                    <v-flex
                      v-for="(item, i) in menus"
                      :key="i"
                      sm4
                      md4
                      lg3
                      xl2
                      align-self-center
                      text-right
                    >
                      <a
                        class="hov"
                        target="_blank"
                        href="assets/Pressrelease.pdf"
                      >
                        <span
                          :class="
                            $vuetify.breakpoint.name == 'md'
                              ? 'MDapplist'
                              : 'LGapplist'
                          "
                        >
                          {{ item.name }}
                        </span>
                      </a>
                    </v-flex>
                    <v-flex sm4 md4 lg3 xl2 align-self-center text-right>
                      <router-link class="routerlink hov" to="/PrivacyPolicy">
                        <span
                          :class="
                            $vuetify.breakpoint.name == 'md'
                              ? 'MDapplist'
                              : 'LGapplist'
                          "
                        >
                          Privacy Policy
                        </span>
                      </router-link>
                    </v-flex>
                      <!-- <v-flex sm4 md4 lg3 xl2 align-self-center text-right>
                       <a
                        class="hov"
                        target="_blank" href="https://forms.gle/mVhPFTSvGSAM2bLEA" style="color: #F6A448;"
                      >
                        <span
                          :class="
                            $vuetify.breakpoint.name == 'md'
                              ? 'MDapplist'
                              : 'LGapplist'
                          "
                          style="color: #F6A448;"
                        >
                          Apply Now
                        </span>
                       </a>
                    </v-flex> -->
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- <v-flex align-self-center>
              <v-layout wrap justify-end>
                <v-flex sm12 md12 lg12 align-self-center>
                  <v-layout wrap>
                    <v-flex
                      v-for="(item, i) in menus"
                      :key="i"
                      md2
                      lg2
                      align-self-center
                      text-center
                    >
                      <router-link class="routerlink" :to="item.route">
                        <span
                          :class="
                            $vuetify.breakpoint.name == 'md'
                              ? 'MDapplist'
                              : 'LGapplist'
                          "
                          >{{ item.name }}</span
                        >
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex> -->
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
import AppHeader from "./../layout/AppHeader";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      sideNav: true,
      transAppBar: true,
      // userNavItems: [
      //   { name: "Rules", route: "/" },
      //   { name: "Resources", route: "/" },
      //   { name: "Project", route: "/" },
      //   { name: "Updates", route: "/" },
      //   { name: "Discussion", route: "/" },
      //   { name: "FAQ", route: "/" },
      // ],
      userNavItems: [
        // { name: "About Us", route: "/About" },
        { name: "Press release", route: "/" },
      ],
    };
  },
  computed: {
    // appType() {
    //   return this.$store.state.userType;
    // },
    menus() {
      return this.userNavItems;
    },
  },
};
</script>
<style>
@media only screen and (min-device-width: 767px) {
  .fixedSidebar {
    /* position: fixed; */

    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 50;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-width: 640px) {
  .fixedSidebar {
    display: none !important;
  }
}
.hov:hover {
  color: blue !important;
}
</style>